import { render, staticRenderFns } from "./Repport.vue?vue&type=template&id=54a66daa&scoped=true&"
import script from "./Repport.vue?vue&type=script&lang=js&"
export * from "./Repport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a66daa",
  null
  
)

export default component.exports